<!-- トヨタコニック対応にて追加  -->
<template>
  <div v-if="isVisible" class="modal-overlay" @click="handleOverlayClick">
    <div class="modal-wrapper" @click.stop>
      <div class="modal-inner-wrapper" v-show="isContentLoaded">
        <div class="modal-container">
          <div class="modal-body">
            <CMS
              @sendComplete="handleCMSDataLoaded"
              contents_type="block_contents"
              location_code="CRPG_TOP_05_001-kiyaku"
            />
          </div>
          <div class="modal-checkbtn">
            <input type="checkbox" id="doNotShowAgain" v-model="doNotShowAgain">
            <label for="doNotShowAgain">次回以降は表示させない</label>
          </div>
          <button class="modal-close" @click="closeModal">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { getAccessCookie, setAccessCookie } from "@/utils/cookie.js";
import CMS from "@/components/CMS.vue";

export default {
  name: "CrpgOrganismsPopupModal",
  components: {
    CMS,
  },
  computed: {
  // 環境変数からサブディレクトリの配列を取得
  subDirectories() {
    return process.env.VUE_APP_SUBDIRECTORY.split(";");
  },
  // 現在のURLがいずれかのサブディレクトリを含むかどうかを判断
  isSubDirectoryActive() {
    console.log(this.$route.path);
    return this.subDirectories.some(subDir => this.$route.path.includes(subDir));
  },
  // クッキー名を決定するために使用するサブディレクトリ名を取得
  getSubDirName() {
    const subDir = this.subDirectories.find(subDir => this.$route.path.includes(subDir)) || "";
    const trimmedSubDir = subDir.replace(/^\/|\/$/g, "");
    return `${trimmedSubDir}`;
  }
},
  data() {
    return {
      isVisible: false,
      isContentLoaded: false,
    };
  },
  created() {
    this.checkModalDisplay();
  },
  methods: {
    checkModalDisplay() {
      if (!this.isSubDirectoryActive) {
        return;
      }
      const access = getAccessCookie(this.getSubDirName);
      this.isVisible = !access || access === "false";
    },
    handleCMSDataLoaded() {
      this.isContentLoaded = true;
    },
    closeModal() {
      if (this.isVisible) {
        if (this.doNotShowAgain) {
          console.log(this.doNotShowAgain)
          setAccessCookie(this.getSubDirName, 180);
        } else {
          setAccessCookie(this.getSubDirName, 1);
        }
        this.isVisible = false;
      }
    },
    handleOverlayClick() {
      // オーバーレイをクリックしても何もしない
    }
  }
};
</script>


<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.modal-wrapper {
    display: flex;
    position: relative;
    box-sizing: border-box;
}

.modal-inner-wrapper {
    display: flex;
    flex-direction: column;
    background: white;
    padding: 20px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.modal-container {
    width: 100%;
    text-align: center;
}

.modal-body {
    overflow-y: auto;
}

.modal-checkbtn {
    margin-top: 20px;
    text-align: center;
}

.modal-close {
    margin-top: 20px;
    cursor: pointer;
    background: #f1f1f1;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    transition: background-color 0.3s ease;
}

.modal-close:hover {
    background-color: #e0e0e0;
}

</style>
